import api from "./api";

export async function generateVerticalSeedDraft(payload) {
    const res = await api.post("/admin/vertical-seeds/generate-draft", payload);
    return res.data;
}

export async function approveVerticalSeed(id) {
    const res = await api.post(`/admin/vertical-seeds/${id}/approve`);
    return res.data;
}

export async function getVerticalSeeds() {
    const res = await api.get("/admin/vertical-seeds");
    return res.data;
}

export async function getActiveVerticalSeed({ industry, subIndustry, templatePackKey }) {
    const params = new URLSearchParams();

    if (industry) params.append("industry", industry);
    if (subIndustry) params.append("subIndustry", subIndustry);
    if (templatePackKey) params.append("templatePackKey", templatePackKey);

    const res = await api.get(`/admin/vertical-seeds/active?${params.toString()}`);
    return res.data;
}

export async function runVerticalSeedBatch(payload) {
    const res = await api.post("/admin/vertical-seeds/batch/generate-drafts", payload);
    return res.data;
}